export enum Language {
  English = "en",
  Dutch = "nl",
  French = "fr",
  German = "de",
  Italian = "it",
}
export enum LanguageUppercase {
  English = "EN",
  Dutch = "NL",
  French = "FR",
  German = "DE",
  Italian = "IT",
}
